<template>
  <Panel class="page-message" :padding="[20, 24]">
    <img :src="computedImg" alt="" />
    <div class="page-message-introduce">
      <div class="title">
        <p>{{ `${computedTestType + currentLevelIndex}` }}</p>
        <a href="https://wohuimandarin.com" style="display: flex; align-items: center; cursor: pointer" target="_blank">
          <span> {{ $t("test_course_link") }}</span>
          <SvgIcon type="arrow-right" class="icon-18"></SvgIcon>
        </a>
      </div>
      <div class="text">
        <div style="display: flex; align-items: center; cursor: pointer" @click="openIntroduce()">
          <p>
            {{ introduce }}
            <span class="m-l-10" style="color: #b5b5be">{{ $t("test_complete_introduce") }}</span>
            <SvgIcon type="arrow-right" class="icon-18" style="vertical-align: -5px"></SvgIcon>
          </p>
        </div>
      </div>
      <div class="about-download" :style="{ visibility: downLoadList && downLoadList.length ? '' : 'hidden' }">
        <div class="title">{{ $t("test_about_down_load") }}</div>
        <div class="down-list">
          <div class="down-list-item" v-for="(item, index) in downLoadList" :key="index">
            <SvgIcon type="download" class="download"></SvgIcon>
            <a :href="item.download_url" target="_blank">
              <span>{{ `${computedTestType}${currentLevelIndex}&nbsp; ${item.res_title}` }}</span></a
            >
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogIntroduceVisible" top="20vh" width="900px" custom-class="dialog">
      <div class="dialog-header">
        <div class="title">{{ `${computedTestType + currentLevelIndex}` }}</div>
      </div>
      <div class="dialog-body">
        <div v-for="(item, index) in completeIntroduce" :key="index" class="introduce_list">
          <strong>{{ item.title }}</strong>
          <pre>{{ item.content }}</pre>
        </div>
      </div>
    </el-dialog>
  </Panel>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import { testConfig } from "@/config";
import { uploadFile } from "@/utils/utils";
import { mapState } from "vuex";
export default {
  components: {
    SvgIcon,
  },
  props: {
    currentLevelIndex: {
      default: 1,
      type: Number,
    },
    testType: {
      default: 1,
      type: Number,
    },
  },
  data() {
    return {
      dialogIntroduceVisible: false,
      tableData: [
        {
          partCode: "第一部分",
          questionCount: 5,
          duration: "约15分钟",
          questionCountMoudleTotal: 20,
          segmentCode: "听力",
          totalDuration: "约35分钟",
          totalQuestionCount: "40",
        },
        {
          partCode: "第二部分",
          questionCount: 5,
          duration: "约15分钟",
          questionCountMoudleTotal: 20,
          segmentCode: "听力",
          totalDuration: "约35分钟",
          totalQuestionCount: "40",
        },
        {
          partCode: "第三部分",
          questionCount: 5,
          duration: "约15分钟",
          questionCountMoudleTotal: 20,
          segmentCode: "听力",
          totalDuration: "约35分钟",
          totalQuestionCount: "40",
        },
        {
          partCode: "第四部分",
          questionCount: 5,
          duration: "约15分钟",
          questionCountMoudleTotal: 20,
          segmentCode: "听力",
          totalDuration: "约35分钟",
          totalQuestionCount: "40",
        },
        {
          partCode: "第一部分",
          questionCount: 5,
          duration: "17分钟",
          questionCountMoudleTotal: 20,
          segmentCode: "阅读",
          totalDuration: "35分钟",
          totalQuestionCount: "40",
        },
        {
          partCode: "第二部分",
          questionCount: 5,
          duration: "17分钟",
          questionCountMoudleTotal: 20,
          segmentCode: "阅读",
          totalDuration: "35分钟",
          totalQuestionCount: "40",
        },
        {
          partCode: "第三部分",
          questionCount: 5,
          duration: "17分钟",
          questionCountMoudleTotal: 20,
          segmentCode: "阅读",
          totalDuration: "35分钟",
          totalQuestionCount: "40",
        },
        {
          partCode: "第四部分",
          questionCount: 5,
          duration: "17分钟",
          questionCountMoudleTotal: 20,
          segmentCode: "阅读",
          totalDuration: "35分钟",
          totalQuestionCount: "40",
        },
      ],
      introduce: "",
      downLoadList: [],
      completeIntroduce: "",
    };
  },
  computed: {
    ...mapState({
      levelActive: (state) => state.level.levelActive,
    }),
    computedTestType() {
      const compare = (a, b) => a == b;
      return Object.keys(testConfig).find((item) => compare(testConfig[item], this.testType));
    },
    computedImg() {
      return require(`@/assets/images/${this.computedTestType.toLowerCase()}_level${Number(
        this.currentLevelIndex,
      )}.png`);
    },
    computedLevelId() {
      return Number(this.levelActive || localStorage.getItem("LevelActive"));
    },
  },
  watch: {
    computedLevelId: {
      handler() {
        this.getIntroduce();
      },
      immediate: true,
    },
  },
  methods: {
    openIntroduce() {
      this.dialogIntroduceVisible = true;
    },
    // 合并行
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 3 || columnIndex === 5) {
        const arr = this.getSpan(this.tableData);
        const row = arr[rowIndex].row;
        const col = arr[rowIndex].col;
        return {
          rowspan: row,
          colspan: col,
        };
      } else if (columnIndex === 4 || columnIndex === 6) {
        let sum = this.sumPart();
        if (rowIndex % sum === 0) {
          return {
            rowspan: sum,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    // 隐藏掉不需要的表头
    discountHeaderStyle({ rowIndex }) {
      if (rowIndex == 1) {
        return { display: "none" };
      }
    },
    // 判断一共有多少个部分
    sumPart() {
      return this.tableData.length;
    },
    getSpan(list) {
      const newArr = [];
      const obj = {};
      for (let i = 0; i < list.length; i++) {
        if (i === 0) {
          obj.row = 1;
          obj.col = 1;
          newArr.push(obj);
        } else {
          if (list[i].segmentCode === list[i - 1].segmentCode) {
            newArr.push({ row: 0, col: 0 });
            const index = list.findIndex((item) => {
              return item.segmentCode === list[i - 1].segmentCode;
            });
            newArr[index].row++;
          } else {
            newArr.push({ row: 1, col: 1 });
          }
        }
      }
      return newArr;
    },
    // 下载文件
    downLoadFile(url, name) {
      uploadFile({
        url,
        name,
      });
    },
    // 获取介绍信息
    getIntroduce() {
      window.utilV2.getData(
        window.ApiPath.hsk_get_level_detail,
        { level_id: this.computedLevelId },
        (data) => {
          this.introduce = data?.desc;
          this.downLoadList = data?.res_download;
          this.completeIntroduce = data?.contents;
        },
        null,
        {
          authorization: true,
          showLoading: false,
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.page-message {
  padding: 20px 24px;
  margin-bottom: 16px;
  display: flex;
  img {
    width: 130px;
    height: 156px;
  }
  &-introduce {
    flex: 1;
    margin-left: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      p {
        font-weight: 500;
        font-size: 28px;
        line-height: 32px;
        color: #2c2f46;
      }
      span {
        font-weight: 400;
        font-size: 14px;
        line-height: 14px;
        text-align: right;
        color: #b5b5be;
      }
      a {
        &:hover {
          text-decoration: none;
        }
      }
    }
    .text {
      margin-top: 8px;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #696974;
      word-break: break-word;
    }
    .about-download {
      margin-top: 16px;
      .title {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #2c2f46;
      }
      .down-list {
        display: flex;
        margin-top: 8px;
        &-item {
          padding: 6px 12px;
          background: #fafafb;
          border-radius: 6px;
          margin-right: 16px;
          display: flex;
          align-items: center;
          cursor: pointer;
          .download {
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }
          a {
            color: #696974;
          }
        }
      }
    }
  }
  .dialog-header {
    width: 100%;
    height: 112px;
    background-image: url(~@/assets/images/introduce_header_bg.png);
    .title {
      padding-top: 32px;
      padding-left: 24px;
      color: #ffffff;
      font-weight: 700;
      font-size: 28px;
      line-height: 28px;
    }
  }
  .dialog-body {
    padding: 12px 24px;
    max-height: 588px;
    overflow: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    p {
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: #2c2f46;
    }
    pre {
      background: transparent;
      line-height: 30px;
      white-space: pre-wrap;
      word-break: break-word;
    }
    ::v-deep.el-table tbody tr:hover > td {
      background-color: #ffffff !important;
    }
    .introduce_list {
      margin-bottom: 10px;
      line-height: 25px;
      strong {
        font-weight: bold;
        word-break: break-word;
        font-size: 16px;
      }
    }
  }
  ::v-deep .el-dialog {
    border-radius: 12px;
    &__header {
      padding: 0;
    }
    &__body {
      padding: 0;
    }
  }
}
</style>
